/* Citação Direta do Insumo — textarea com contador de caracteres + alerta. */
import { Languages, FileText } from "lucide-react";

const MAX_RECOMMENDED = 3000;  // ≈ 1 página A4
const MAX_HARD = 4500;

export default function CitacaoDireta({
  value = "",
  onChange,
  paginaOuSecao = "",
  onChangePagina,
  trechoTraduzidoPt = "",
  onChangeTrecho,
  onTranslate,                  // opcional: callback p/ traduzir via IA
  translateBusy = false,
}) {
  const len = (value || "").length;
  const tooLong = len > MAX_RECOMMENDED;
  const farTooLong = len > MAX_HARD;
  return (
    <div className="space-y-3" data-testid="citacao-direta">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="md:col-span-2">
          <div className="flex items-end justify-between mb-1">
            <label className="label-mil flex items-center gap-1">
              <FileText size={11} /> Citação Direta do Insumo
            </label>
            <span
              className={`text-[10px] font-mono ${farTooLong ? "text-[var(--danger)]" : tooLong ? "text-[var(--warn)]" : "text-[var(--text-muted)]"}`}
              data-testid="citacao-counter"
            >
              {len.toLocaleString("pt-BR")} / {MAX_RECOMMENDED.toLocaleString("pt-BR")} caracteres
            </span>
          </div>
          <textarea
            className="input-mil"
            rows={5}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Trecho literal em português, até uma página"
            data-testid="citacao-textarea"
          />
          <div className="text-[10px] text-[var(--text-muted)] mt-1">
            Trecho literal em português, até uma página (~3000 caracteres). Mantenha pontuação e termos originais.
          </div>
          {tooLong && (
            <div className={`text-[10px] mt-1 ${farTooLong ? "text-[var(--danger)]" : "text-[var(--warn)]"}`}>
              {farTooLong
                ? "Trecho excede o limite metodológico — divida em múltiplos insumos."
                : "Trecho próximo do limite de 1 página. Considere reduzir ou dividir em múltiplos insumos."}
            </div>
          )}
        </div>
        <div className="space-y-2">
          <label className="label-mil block">Página ou Seção</label>
          <input
            className="input-mil"
            value={paginaOuSecao}
            onChange={(e) => onChangePagina && onChangePagina(e.target.value)}
            placeholder="ex.: p. 42 ou Seção 3.1"
            data-testid="pagina-ou-secao"
          />
          {onTranslate && (
            <button
              type="button"
              onClick={onTranslate}
              disabled={translateBusy || !value || len < 20}
              className="btn-ghost text-xs flex items-center justify-center gap-1 w-full disabled:opacity-50"
              title="Traduzir ou normalizar para português usando IA"
              data-testid="citacao-translate-btn"
            >
              <Languages size={12} /> {translateBusy ? "Traduzindo…" : "Traduzir / Normalizar p/ PT"}
            </button>
          )}
        </div>
      </div>
      {onChangeTrecho && (
        <details className="border border-[var(--border)] rounded p-2">
          <summary className="text-[11px] text-[var(--text-muted)] cursor-pointer">
            Trecho traduzido ao português (opcional — preencha se o original estiver em outro idioma)
          </summary>
          <textarea
            className="input-mil mt-2"
            rows={3}
            value={trechoTraduzidoPt}
            onChange={(e) => onChangeTrecho(e.target.value)}
            placeholder="Tradução fiel ao português brasileiro"
            data-testid="citacao-trecho-pt"
          />
        </details>
      )}
    </div>
  );
}
